import { Svg } from "@vividtheory/minerva-lab";
import React from "react";
const SvgKeepOutline = (props) => (React.createElement(Svg, Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "currentColor", d: "M15.7885 11.7115L17.577 13.5V15H13.0385V20.5L12.2885 21.25L11.5385 20.5V15H7V13.5L8.7885 11.7115V4.5H7.7885V3H16.7885V4.5H15.7885V11.7115ZM9.1385 13.5H15.4385L14.2885 12.35V4.5H10.2885V12.35L9.1385 13.5Z" })));
export default SvgKeepOutline;
SvgKeepOutline.displayName = "SvgKeepOutline";
//# sourceMappingURL=KeepOutline.js.map